// Shared mobile city sort definitions used by both the standalone Cities list
// and the Country-scoped Cities list. Each page picks its own subset of
// fields for its sort drawer (e.g. the Country-scoped page omits "country"
// since every row already belongs to the same country).
export const mobileCitySortDefinitions = {
    cityName: {
        defaultDirection: 'asc',
        type: 'text',
        value: (city) => String(city.cityName || city.name || '').trim(),
    },
    country: {
        defaultDirection: 'asc',
        type: 'text',
        value: (city) => String(city.countryName || city.country?.name || '').trim(),
    },
    population: {
        defaultDirection: 'desc',
        type: 'number',
        value: (city) => {
            const value = city.regionCitizensNumber;
            if (value === null || value === undefined || value === '') return null;
            const population = Number(value);
            return Number.isFinite(population) ? population : null;
        },
    },
};

export const getMobileSortedCities = (sourceCities, field, direction) => {
    const definition = mobileCitySortDefinitions[field];
    if (!definition) return sourceCities;
    const multiplier = direction === 'asc' ? 1 : -1;

    return [...sourceCities].sort((a, b) => {
        const rawA = definition.value(a);
        const rawB = definition.value(b);
        const aMissing = rawA === null || rawA === undefined || rawA === '';
        const bMissing = rawB === null || rawB === undefined || rawB === '';

        if (aMissing !== bMissing) return aMissing ? 1 : -1;
        if (aMissing && bMissing) return 0;

        const comparison = definition.type === 'text'
            ? String(rawA).toLowerCase().localeCompare(String(rawB).toLowerCase())
            : rawA - rawB;
        return comparison * multiplier;
    });
};
